import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  ChatCircleDotsIcon,
  DatabaseIcon,
  PlugsIcon,
  GearIcon,
  GhostIcon,
  SignOutIcon,
  ClockIcon,
} from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth.jsx";

const NAV = [
  { to: "/", label: "Chat", icon: ChatCircleDotsIcon, end: true, tid: "nav-chat" },
  { to: "/knowledge", label: "Knowledge", icon: DatabaseIcon, tid: "nav-knowledge" },
  { to: "/schedules", label: "Schedules", icon: ClockIcon, tid: "nav-schedules" },
  { to: "/connections", label: "Connections", icon: PlugsIcon, tid: "nav-connections" },
  { to: "/settings", label: "Settings", icon: GearIcon, tid: "nav-settings" },
];

export default function Layout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="h-screen flex bg-zinc-950 text-zinc-100" data-testid="app-layout">
      {/* Rail */}
      <aside className="w-16 border-r border-zinc-800 bg-zinc-950 flex flex-col items-center py-4 gap-1 shrink-0">
        <div className="w-10 h-10 rounded-sm border border-zinc-800 bg-black flex items-center justify-center mb-4">
          <GhostIcon size={22} weight="duotone" className="text-white" />
        </div>
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            data-testid={n.tid}
            className={({ isActive }) =>
              `w-10 h-10 flex items-center justify-center rounded-sm transition-colors ${
                isActive
                  ? "bg-zinc-800 text-white"
                  : "text-zinc-500 hover:bg-zinc-900 hover:text-white"
              }`
            }
            title={n.label}
          >
            <n.icon size={20} weight="regular" />
          </NavLink>
        ))}
        <div className="flex-1" />
        <button
          data-testid="logout-button"
          onClick={() => {
            logout();
            navigate("/login");
          }}
          className="w-10 h-10 flex items-center justify-center rounded-sm text-zinc-500 hover:bg-zinc-900 hover:text-white transition-colors"
          title="Logout"
        >
          <SignOutIcon size={20} />
        </button>
      </aside>

      <main className="flex-1 overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
